import AlarmNotificationsController from './alarm-notifications.controller';

require('./alarm-notifications.scss');

const AlarmNotificationsComponent = {
    selector: 'sbAlarmNotifications',
    controller: AlarmNotificationsController,
    template: require('./alarm-notifications.html'),
};

export default AlarmNotificationsComponent;



// WEBPACK FOOTER //
// ./src/app/components/alarm-notifications/index.js